import { FC, useEffect, useState } from "react";
import { FieldValues, UseFormWatch } from "react-hook-form";
import FormSelect from "../../../components/molecule/Select/FormSelect";
import { getIndicator } from "../../../services/Indicator/getIndicator";
import { Button, Flex, VStack } from "@chakra-ui/react";
import AccordionComponent from "../../../components/atom/Accordion/AccordionComponent";

interface IndicatorAlertSanFieldProps {
  control: any;
  errors: any;
  watch: UseFormWatch<FieldValues>;
  index: number;
  remove: () => void;
  frequencyId?: number;
}

const IndicatorAlertSanField: FC<IndicatorAlertSanFieldProps> = ({
  control,
  errors,
  watch,
  index,
  remove,
  frequencyId,
}) => {
  const [indicatorName, setIndicatorName] = useState<string | null>(null);
  const selectedIndicator = watch(`indicators[${index}].indicatorOptions`);
  useEffect(() => {
    if (selectedIndicator?.name) {
      setIndicatorName(selectedIndicator.name);
    } else {
      setIndicatorName(null);
    }
  }, [selectedIndicator]);

  const accordionTitle = indicatorName
    ? `INDICADOR ${index + 1} | ${indicatorName.toUpperCase()}`
    : `INDICADOR ${index + 1}`;

  const fetchIndicatorsWithFrequency = () => {
    const filterValues = frequencyId ? { FrequencyId: frequencyId } : {};
    return getIndicator(undefined, filterValues);
  };

  return (
    <AccordionComponent accordionTitle={accordionTitle} fontSize="sm">
      <Flex alignItems="flex-end" justifyContent="space-between">
        <VStack gap="4">
          <FormSelect
            control={control}
            errors={errors}
            watch={watch}
            fieldName={`indicators[${index}].indicatorOptions`}
            fieldLabel="Seleccione o indicador"
            fetchOptions={fetchIndicatorsWithFrequency}
          />
        </VStack>
        <Button variant="secondary" colorScheme="red" onClick={remove}>
          Eliminar indicador
        </Button>
      </Flex>
    </AccordionComponent>
  );
};

export default IndicatorAlertSanField;
